// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"600711b9d795cef2f3c7","339":"53952f07cbd7713b7677"}[chunkId] + ".js";
};